"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useBreakpointIndex = void 0;
var _mui = require("@ori-ui/mui");
/**
 * @returns Zero-based breakpoint index as one of the following:
 * 0 - Small "mobile" screen based on the predefined 'sm' breakpoint.
 * 1 - Larger "desktop" screens.
 */ const useBreakpointIndex = ()=>{
    const theme = (0, _mui.useTheme)();
    const isSmallScreen = (0, _mui.useMediaQuery)(theme.breakpoints.down('sm'), {
        noSsr: true
    });
    return isSmallScreen ? 0 : 1;
};
exports.useBreakpointIndex = useBreakpointIndex;
